import Swiper from 'swiper'

let swiperInstance = null

let width = window.innerWidth
let isSp = width <= 1024 ? true : false
const cardsPerView = isSp ? 2 : 5
// const scrollBarWidth = isSp ? 100 : 100
let scrollBarWidth
if (width <= 768) {
  scrollBarWidth = width / 3.4
} else if (width <= 1024) {
  scrollBarWidth = 70
} else {
  scrollBarWidth = width / 11
}

let lastSlideNum = isSp ? 2 : 5

// Swiper初期化
export const initializeSwiper = () => {
  swiperInstance = new Swiper('#swiperHeader', {
    // Swiperのオプション
    direction: 'horizontal',
    loop: false,
    slidesPerView: cardsPerView,
    slidesPerGroup: 1,
    navigation: {
      // enabled: true,
      nextEl: '.next',
      prevEl: '.prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    spaceBetween: isSp ? 12 : 10,
    on: {
      slideChange: (swiper) => updateScrollbar(swiper),
    },
  })
  function preventFocusAndSelection(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  const nextButton = document.querySelector('.next')
  const prevButton = document.querySelector('.prev')

  if (nextButton) {
    nextButton.addEventListener('mousedown', preventFocusAndSelection)
    nextButton.addEventListener('click', function (event) {
      if (!this.classList.contains('swiper-button-disabled')) {
        swiper.slideNext()
      } else {
        event.preventDefault()
        event.stopPropagation()
      }
    })
  }

  if (prevButton) {
    prevButton.addEventListener('mousedown', preventFocusAndSelection)
    prevButton.addEventListener('click', function (event) {
      if (!this.classList.contains('swiper-button-disabled')) {
        swiper.slidePrev()
      } else {
        event.preventDefault()
        event.stopPropagation()
      }
    })
  }
  const checkActiveSlide = () => {
    const slides = document.querySelectorAll('.swiper-slide:has(.swiper-slide)')
    if (slides.length > 0) {
      const firstSlide = slides[0]
      const lastSlide = slides[slides.length - lastSlideNum]
      if (firstSlide.classList.contains('swiper-slide-active')) {
        prev.classList.add('swiper-button-disabled')
      } else {
        prev.classList.remove('swiper-button-disabled')
      }
      if (lastSlide.classList.contains('swiper-slide-active')) {
        next.classList.add('swiper-button-disabled')
      } else {
        next.classList.remove('swiper-button-disabled')
      }
    }
  }
  const swiper = document.querySelector('#swiperHeader').swiper
  const next = document.querySelector('.next')
  const prev = document.querySelector('.prev')
  checkActiveSlide()
  next.addEventListener('click', (e) => {
    swiper.slideNext()
    checkActiveSlide()
  })
  prev.addEventListener('click', (e) => {
    swiper.slidePrev()
    checkActiveSlide()
  })

  updateScrollbar()
}

const updateScrollbar = (swiper) => {
  const scrollbarEl = document.querySelector('.swiper-scrollbar-drag')
  if (scrollbarEl) {
    const {activeIndex, slides, params} = swiper ? swiper : swiperInstance
    const slidesCount = slides.length
    const slidesPerView = params.slidesPerView

    // 計算するための全体幅とスクロールバーの幅
    const swiperWidth = swiperInstance.width - scrollBarWidth
    const scrollbarWidth = (swiperWidth / slidesCount) * slidesPerView

    // スクロールバーの位置を計算
    const newLeft =
      (activeIndex / (slidesCount - slidesPerView)) *
      (swiperWidth - scrollbarWidth)

    // スクロールバーの幅と位置を設定
    scrollbarEl.style.width = `${scrollbarWidth}px`
    scrollbarEl.style.transform = `translateX(${newLeft}px)`
  }
}

// export const reinitializeSwiper = () => {
//   if (swiperInstance !== null) {
//     swiperInstance.destroy() // 現在のSwiperインスタンスを破棄
//     swiperInstance = null
//   }
//   initializeSwiper() // Swiperを再初期化
// }
